export enum WorkspaceFileType {
  Snippet = 'snippet',
  TemplatePage = 'templatepage',
  Topic = 'topic',
  ConditionTagSet = 'conditiontagset',
  VariableSet = 'variableset',
  Target = 'target',
  Toc = 'toc',
  Stylesheet = 'stylesheet',
  Destination = 'destination',
  Project = 'project',
  Code = 'code'
}
